<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div
          v-for="(item, index) in line"
          :key="index"
          class="line-item"
          :class="{ lineItemBlank: !!type }"
        >
          <div class="line-head">
            <img :src="item.headImg" alt="headImg" />
          </div>
          <div class="line-right">
            <div class="line-cont">
              <div class="v-line-desc text-overflow">
                {{ item.desc }}
              </div>
            </div>
            <div @click="jumpToSight(item.linkId)" v-maidian="'line_' + index" class="line-btm clear">
              <div class="price">
                <span class="price-span">
                  <!-- <i>{{ discount ? item.price * 0.8 : item.price }}</i> -->
                  <i>点击查看</i>
                </span>
                <mt-button size="small"
                  >立即预定</mt-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bg-line"></div>
      </div>
    </div>
    <!-- <img class="tip"
      src="https://s.qunarzz.com/srmweb/qunaradv/changma202203/29.png"
      alt=""
    /> -->
  </div>
</template>
<script>
export default {
  props: ['lineList', 'showMore', 'type'],
  data() {
    return {
      discount: false,
    };
  },
  methods: {
    jumpToSight(linkId) {
      location.href = linkId;
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
  margin-top: 20px;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.descList{
  height: 43px;
}
.line {
  position: relative;
  &-box {
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    border-radius: 3px;
    width: calc(100% - 32px);
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 100%;
    background-color: #fff;
    float: left;
    z-index: 2;
    margin-bottom: 14px;
    height: 150px;
    margin-bottom: 15px;
    display: flex;
    .line-head {
      width: 131px;
      overflow: hidden;
      position: relative;
      border-radius: 5px;
      img {
        height: 100%;
        width: auto;
        max-width: inherit;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .line-right {
      width: calc(100% - 118px);
      box-sizing: border-box;
      padding-top: 10px;
      padding-left: 14px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 15px;
    }
    &-box {
      position: relative;
      margin-bottom: 7px;
      &:last-child {
        margin-bottom: 0;
      }
      // .bg-line {
      //     background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
      //         no-repeat;
      //     background-size: 100% auto;
      //     height: 20px;
      //     width: 100%;
      //     position: absolute;
      //     left: 0;
      //     bottom: 7px;
      // }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
    -webkit-line-clamp:3;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding-bottom: 0;
  }
  &-btm {
    .price {
      background: url(https://source.qunarzz.com/site/images/wns/20221220-shijianchen-btn.png)
        no-repeat;
      background-size: 100% 100%;
      height: 26px;
      display: flex;
      width: 178px;
      margin-top: 10px;
      align-items: center;
      justify-content: space-between;
      font-weight: bold;
      &-span {
        height: 26px;
        line-height: 26px;
        text-align: left;
        font-weight: bold;
        float: left;
        font-size: 18px;
        color: #905F3F;
        width: 103px;
        display: flex;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        i {
          font-style: normal;
          font-size: 11px;
        }
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
      }
      button {
        position: relative;
        float: right;
      }
    }
  }
  &-head {
    img {
      display: block;
      height: 95px;
      width: 100%;
    }
  }
  .price {
    display: flex;
    align-items: center;
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background-color: transparent;
    border-radius: 6px;
    color: rgba(242, 221, 198, 1);
    font-size: 10px;
    height: 26px;
    width: 75px;
    padding: 0;
    box-shadow: none;
    font-weight: bold;
    margin-left: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    background: rgba(255, 63, 79, 1);
    border-radius: 3px 0px 3px 0px;
  }
}
.line-cont-desc {
  font-size: 9px;
  color: #6a6a6a;
  text-align: left;
  margin-top: 1px;
}
.v-line-desc {
  text-align: left;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  margin-bottom: 8px;
  padding-right: 26px;
  -webkit-line-clamp:3;
}
.tip {
  width: 280px;
  display: block;
  margin: 0 auto;
}
.lineItemBlank {
  background: url(https://source.qunarzz.com/site/images/wns/20221205-shijianchen-touming.png)
    no-repeat;
  background-size: 100% 100%;
  .line-cont * {
    color: #fff;
  }
}
</style>